// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__2oxVX","title":"AfterBackImages_title__P5GyR","images":"AfterBackImages_images__359gk"};